<template>
  <v-dialog
    :value="value"
    scrollable
    max-width="900"
    @input="$emit('input', $event)"
  >
    <v-card v-if="record" rounded="0">
      <v-toolbar color="kenyaGreen" dark flat>
        <v-toolbar-title class="font-weight-bold">
          {{ $t('memberDataSection.processingBatchBulkImport.detailsTitle') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="px-6 py-5" style="max-height: 72vh">
        <div class="d-flex align-center mb-4">
          <h3 class="font-weight-bold black--text">
            {{ $t('memberDataSection.processingBatchBulkImport.detailsTitle') }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="$emit('edit', record)">
            {{ $t('edit') }}
          </v-btn>
        </div>

        <!-- Issue alert -->
        <div
          v-if="hasIssues"
          class="pb-detail-alert mb-5"
          :style="{
            backgroundColor: themeColor('secondary2light'),
            borderColor: themeColor('third'),
          }"
        >
          <p class="font-weight-bold black--text mb-1">{{ issueTitle }}</p>
          <p class="text-body-2 mb-0">{{ issueDescription }}</p>
        </div>

        <!-- Header fields -->
        <v-row dense>
          <v-col
            v-for="field in detailFields"
            :key="field.key"
            cols="12"
            md="6"
            class="mb-2"
          >
            <div class="text-body-2 text--secondary mb-1">{{ $t(field.labelKey) }}</div>
            <div
              class="text-body-1 font-weight-bold"
              :class="field.error ? 'red--text' : 'black--text'"
            >
              {{ field.value }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end py-4 px-6">
        <v-btn outlined color="primary" class="mr-3" min-width="120" @click="$emit('edit', record)">
          {{ $t('edit') }}
        </v-btn>
        <v-btn color="primary" class="white--text" min-width="120" @click="$emit('input', false)">
          {{ $t('memberDataSection.processingBatchBulkImport.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { hasFieldError } from "@/utils/processingBatchBulkImport";

const B = "memberDataSection.processingBatchBulkImport";

export default {
  name: "ProcessingBatchBulkImportDetailDialog",
  props: {
    value: { type: Boolean, default: false },
    record: { type: Object, default: null },
    issueTitle: { type: String, default: "" },
    issueDescription: { type: String, default: "" },
  },
  computed: {
    rec() {
      return (this.record && this.record.recordedJsonData) || {};
    },
    hasIssues() {
      return Boolean(this.record && (this.record.errorCodes || []).length);
    },
    detailFields() {
      const fields = [
        { key: "processDate",   labelKey: `${B}.processDateCol` },
        { key: "orderCodes",    labelKey: `${B}.purchaseOrdersCol`,  isArray: true },
        { key: "processType",   labelKey: `${B}.processTypeCol`,     errorKey: "processType" },
        { key: "grade",         labelKey: `${B}.gradeCol` },
        { key: "season",        labelKey: `${B}.seasonCol` },
        { key: "parchmentKg",   labelKey: `${B}.parchmentCol`,       errorKey: "parchmentKg" },
        { key: "bags",          labelKey: `${B}.bagsCol` },
        { key: "vehiclePlate",  labelKey: `${B}.vehiclePlateCol` },
        { key: "harvested",     labelKey: `${B}.harvestedCol` },
        { key: "pulped",        labelKey: `${B}.pulpedCol` },
        { key: "washed",        labelKey: `${B}.washedCol` },
        { key: "dryingStarted", labelKey: `${B}.dryingStartedCol` },
        { key: "movedToStore",  labelKey: `${B}.movedToStoreCol` },
      ];
      return fields.map((f) => ({
        ...f,
        value: this.displayValue(this.rec[f.key], f.isArray),
        error: hasFieldError(this.record, f.errorKey || f.key),
      }));
    },
  },
  methods: {
    displayValue(v, isArray) {
      if (isArray) {
        return Array.isArray(v) && v.length ? v.join(", ") : "—";
      }
      return v != null && String(v).trim() !== "" ? v : "—";
    },
    themeColor(name) {
      const theme = this.$vuetify.theme;
      const variant = theme.dark ? "dark" : "light";
      return (theme.themes[variant] && theme.themes[variant][name]) || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.pb-detail-alert {
  border: 1px solid;
  border-radius: 8px;
  padding: 16px 20px;
}
</style>
